import { render, staticRenderFns } from "./AppModalDre.vue?vue&type=template&id=0e133f5c&"
import script from "./AppModalDre.vue?vue&type=script&lang=js&"
export * from "./AppModalDre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports